import { IonCol, IonGrid, IonRow, IonSpinner } from "@ionic/react";
import { useContext, useEffect, useState } from "react";

import Dropdown from "../../Genericos/Dropdown/Dropdown";

import {
  registro,
  resetErrorReg,
} from "../../../context/Actions/registro/registro";
import { PortalContext } from "../../../context/Provider";
import {
  planObraSocial,
  removePlanObraSocial,
} from "../../../context/Actions/planObraSocial/planObraSocial";
import {
  setUsuario,
  setListError,
} from "../../../context/Actions/registro/registro";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import { useHistory } from "react-router";
import { hideModal } from "../../../context/Actions/modal/modal";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { regexNumero } from "../../../../global/utils/expresionesRegulares";
import { hideSegundoModal } from "../../../context/Actions/segundoModal/segundoModal";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../../Genericos/InputV1/InputV1";

const Paso2 = () => {
  const {
    obraSocialState,
    obraSocialDispatch,
    planObraSocialState,
    planObraSocialDispatch,
    registroState,
    registroDispatch,
    multiTabDispatch,
    segundoModalDispatch,
  } = useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const history = useHistory();

  const [obraSocialSeleccionada, setObraSocialSeleccionada] = useState([]);
  const [habilitarNumeroAfiliado, setHabilitarNumeroAfiliado] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const [radio, setRadio] = useState(false);
  //revisar si se sigue usando codigo OBRASOCIAL
  const [codigoObraSocial, setCodigoObraSocial] = useState();
  const [valueObraSocial, setValueObraSocial] = useState("");
  const [valuePlanObraSocial, setValuePlanObraSocial] = useState("");
  const campos = ["obra_social", "plan_obra_social", "nro_afiliado"];

  const changeObraSocial = (obraSocial) => {
    let usuario = Object.assign({}, registroState.registro.usuario);
    let errx = Object.assign({}, registroState.registro.listError);
    if (obraSocial !== "") {
      usuario.obra_social = obraSocial.codigo;
      errx.obra_social = isEmptyError(obraSocial);
      setListError(errx)(registroDispatch);
      setUsuario(usuario)(registroDispatch);
      planObraSocial(obraSocial.codigo)(planObraSocialDispatch);
      setObraSocialSeleccionada(obraSocial);
      setCodigoObraSocial(obraSocial.codigo);

      if (
        obraSocialState.obraSocial.data == null ||
        obraSocial.codigo === "PART"
      ) {
        setRadio(false);
      } else {
        setRadio(true);
      }
      if (obraSocial.codigo === "-1") {
        setCodigoObraSocial("-1");
      }
      if (
        obraSocial !== undefined &&
        obraSocial.ivapredeterminado !== undefined &&
        obraSocial.ivapredeterminado != null &&
        obraSocial.ivapredeterminado !== -1 &&
        obraSocial.abonan === "True"
      ) {
        setRadio(false);
      }
    } else {
      setObraSocialSeleccionada([]);
      setValuePlanObraSocial("");
      removePlanObraSocial()(planObraSocialDispatch);
      usuario.obra_social = "";
      usuario.nro_afiliado = "";
      errx.obra_social = isEmptyError(obraSocial);
      setListError(errx)(registroDispatch);
      setUsuario(usuario)(registroDispatch);
    }
  };
  const changePlanObraSocial = (plan) => {
    if (plan !== undefined) {
      if (plan === "") {
        let errx = Object.assign({}, registroState.registro.listError);
        let usuario = Object.assign({}, registroState.registro.usuario);
        errx.plan_obra_social = true;
        usuario.plan_obra_social = "";
        setListError(errx)(registroDispatch);
        setUsuario(usuario)(registroDispatch);
      } else {
        let usuario = Object.assign({}, registroState.registro.usuario);
        let errx = Object.assign({}, registroState.registro.listError);
        errx.plan_obra_social = false;
        setListError(errx)(registroDispatch);
        usuario.plan_obra_social = plan.id;
        setUsuario(usuario)(registroDispatch);
        setHabilitarNumeroAfiliado(true);
      }
    }
  };
  const onChangeCheckbox = (e) => {
    let usuario = Object.assign({}, registroState.registro.usuario);
    let errx = Object.assign({}, registroState.registro.listError);
    if (e.target.checked) {
      let os = obraSocialState.obraSocial.data.filter(
        (item) => item.codigo === "PART"
      )[0];
      planObraSocial(os.codigo)(planObraSocialDispatch);
      setCodigoObraSocial(os.codigo);
      setObraSocialSeleccionada(os);
      setRadio(false);
      setCheckbox(true);
      usuario.obra_social = os.codigo;
      //prueba iplan por cemedic cargo en plan_obra_social
      usuario.plan_obra_social =
        valuePlanObraSocial !== "" ? valuePlanObraSocial : "";
      usuario.nro_afiliado = "";
      errx.obra_social = false;
      errx.plan_obra_social = false;
      errx.nro_afiliado = false;
      setListError(errx)(registroDispatch);
      setUsuario(usuario)(registroDispatch);
    } else {
      removePlanObraSocial()(planObraSocialDispatch);
      setHabilitarNumeroAfiliado(false);
      setObraSocialSeleccionada(null);
      setCheckbox(false);
      setCodigoObraSocial("");
      usuario.obra_social = "";
      usuario.plan_obra_social = "";
      usuario.nro_afiliado = "";
      setValueObraSocial("");
      setUsuario(usuario)(registroDispatch);
    }
  };

  const preventKeyTexto = (e) => {
    if (!regexNumero.test(e.key)) {
      e.preventDefault();
    }
  };

  const isEmptyError = (empty) => {
    if (empty === "") {
      return true;
    }
    return false;
  };

  const onNroAfiliadoChange = (e) => {
    let usuario = Object.assign({}, registroState.registro.usuario);
    let errx = Object.assign({}, registroState.registro.listError);
    usuario.nro_afiliado = e.target.value;
    errx.nro_afiliado = isEmptyError(e.target.value);
    setUsuario(usuario)(registroDispatch);
    setListError(errx)(registroDispatch);
  };

  const setMultitab = (paso) => {
    setPasoMultiTab(paso)(multiTabDispatch);
  };

  const onChangeRadio = (e) => {
    let usuario = Object.assign({}, registroState.registro.usuario);
    if (e.target.value === "true") {
      usuario.tipo_iva = 0;
      setUsuario(usuario)(registroDispatch);
    } else {
      usuario.tipo_iva = 1;
      setUsuario(usuario)(registroDispatch);
    }
  };

  const crearCuenta = () => {
    let usuarioRegistro = {
      dni: registroState.registro.usuario.nro_documento,
      nombre: (
        registroState.registro.usuario.apellido +
        " " +
        registroState.registro.usuario.nombre
      ).toUpperCase(),
      fecha_nacimiento: registroState.registro.usuario.fecha_nacimiento,
      email: registroState.registro.usuario.email,
      idlocalidad: registroState.registro.usuario.idlocalidad,
      domicilio: registroState.registro.usuario.domicilio,
      telefono: registroState.registro.usuario.telefono,
      telefono_movil: registroState.registro.usuario.telefono_movil,
      obra_social: registroState.registro.usuario.obra_social,
      idplan:
        registroState.registro.usuario.plan_obra_social !== ""
          ? registroState.registro.usuario.plan_obra_social
          : planObraSocialState.planObraSocial.data !== null
          ? planObraSocialState.planObraSocial.data[0].id
          : "",
      nro_afiliado: registroState.registro.usuario.nro_afiliado,
      tipoiva: registroState.registro.usuario.tipo_iva,
      sexo: null,
    };

    let errx = Object.assign({}, registroState.registro.listError);
    errx.obra_social = isEmptyError(registroState.registro.usuario.obra_social);
    if (registroState.registro.usuario.obra_social !== "PART") {
      errx.plan_obra_social = isEmptyError(
        registroState.registro.usuario.plan_obra_social
      );
      errx.nro_afiliado = isEmptyError(
        registroState.registro.usuario.nro_afiliado
      );
    }
    setListError(errx)(registroDispatch);
    let flgError = false;
    campos.forEach((item) => {
      if (errx[item]) flgError = true;
    });
    if (flgError) {
      showToaster(
        {
          texto:
            "El codigo que quiere Validar, es invalido. Por favor, complete el campo correctamente.",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      registro(usuarioRegistro)(registroDispatch);
    }
  };

  useEffect(() => {
    if (registroState.registro.data) {
      showToaster(
        {
          texto:
            "Registro Existoso! Dirigase a su casilla de mail para finalizar el proceso de Registración.",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      setTimeout(() => {
        hideSegundoModal()(segundoModalDispatch);
        history.push("/");
      }, 1000);
    }
  }, [registroState.registro.data]);

  useEffect(() => {
    if (
      registroState.registro.error !== false &&
      registroState.registro.error !== null
    ) {
      const error = registroState.registro.error;

      // Determinar mensaje a mostrar basado en el tipo de error
      let mensajeError;
      let tipoToaster = "danger";

      if (
        error.type === "VALIDATION_ERROR" &&
        error.validationErrors?.length > 0
      ) {
        // Si hay errores de validación específicos, mostrar el primero
        const primerError = error.validationErrors[0];
        mensajeError = primerError.message;
        tipoToaster = "warning";
      } else {
        // Usar el mensaje parseado, con fallback por retrocompatibilidad
        mensajeError = error.detail || "Error al registrar usuario";
      }

      showToaster(
        {
          texto: mensajeError,
          tipo: tipoToaster,
        },
        "centroArriba"
      )(toasterDispatch);
      resetErrorReg()(registroDispatch);
    }
  }, [registroState.registro.error]);
  // mantengo los datos de obra social

  // ----- cargo los dropdown con lo que ya tenia en PASO2
  useEffect(
    () => {
      if (
        Array.isArray(obraSocialState.obraSocial.data) &&
        obraSocialState.obraSocial.data.length > 0
      ) {
        let valueObraSocial = obraSocialState.obraSocial.data.filter(
          (item) => item.codigo === registroState.registro.usuario.obra_social
        );
        if (
          Array.isArray(obraSocialState.obraSocial.data) &&
          valueObraSocial.length > 0
        ) {
          changeObraSocial(valueObraSocial[0]);
          setValueObraSocial(valueObraSocial[0].codigo);
        }
      }
    },
    [
      // obraSocialState.obraSocial.data,
      // registroState.registro.usuario.obra_social,
    ]
  );

  useEffect(() => {
    if (
      Array.isArray(planObraSocialState.planObraSocial.data) &&
      planObraSocialState.planObraSocial.data !== null
    ) {
      if (
        planObraSocialState.planObraSocial.data.length > 0 &&
        planObraSocialState.planObraSocial.data[0].descripcion === "PARTICULAR"
      ) {
        // ultima modificacion 29-9-22 .entiendo que no va, revisar.
        // setValuePlanObraSocial(planObraSocialState.planObraSocial.data[0].id);
      } else {
        if (
          Array.isArray(planObraSocialState.planObraSocial.data) &&
          planObraSocialState.planObraSocial.data.length > 0
        ) {
          let valuePlanObraSocial =
            planObraSocialState.planObraSocial.data.filter(
              (item) =>
                item.id === registroState.registro.usuario.plan_obra_social
            );
          if (
            Array.isArray(planObraSocialState.planObraSocial.data) &&
            valuePlanObraSocial.length > 0
          ) {
            setValuePlanObraSocial(valuePlanObraSocial[0].id);
            changePlanObraSocial(valuePlanObraSocial[0]);
          }
        }
      }
    }
  }, [
    planObraSocialState.planObraSocial.data,
    registroState.registro.usuario.plan_obra_social,
  ]);

  // --- finaliza carga dropdowns.

  return (
    <>
      <IonGrid>
        <div className="ptur-registro-scroll">
          <IonRow>
            <IonCol size="12" sizeMd="12">
              <div className="ptur-registro-noObraSocial">
                <InputV1
                  inputType="check"
                  checkboxStr="No tengo obra social"
                  onChange={onChangeCheckbox}
                  name="txtParticular"
                  checked={
                    registroState.registro.usuario.obra_social !== "" &&
                    registroState.registro.usuario.obra_social === "PART"
                      ? true
                      : false
                  }
                />
              </div>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" sizeMd="12">
              {!checkbox && (
                <div className="ptur-registro-col">
                  <Dropdown
                    headerStr="Obra Social"
                    datos={obraSocialState.obraSocial.data}
                    onChange={changeObraSocial}
                    campoCodigo="codigo"
                    descripcion="nombre"
                    placeholder="Seleccioná una obra social"
                    desactivado={checkbox}
                    valor={valueObraSocial}
                    campoDescripcion={"nombre"}
                    name="txtObraSocial"
                    errorStr="La Obra Social es requerida"
                    checkError={registroState.registro.listError.obra_social}
                    isRequired={true}
                    origen={"OBRA_SOCIAL"}
                  />
                </div>
              )}
              <div className="ptur-registro-col">
                {obraSocialSeleccionada?.codigo !== "PART" && (
                  <Dropdown
                    headerStr="Plan"
                    datos={planObraSocialState.planObraSocial.data}
                    onChange={changePlanObraSocial}
                    campoCodigo="id"
                    descripcion="descripcion"
                    placeholder="Seleccioná un plan"
                    desactivado={
                      !obraSocialSeleccionada?.codigo ||
                      planObraSocialState.planObraSocial.loading
                    }
                    name="txtPlan"
                    errorStr="El Plan es requerido"
                    valor={valuePlanObraSocial}
                    isRequired={true}
                    checkError={
                      registroState.registro.listError.plan_obra_social
                    }
                    origen={"PLAN"}
                  />
                )}
              </div>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol size="12" sizeMd="6">
              <div className="ptur-registro-afiliado">
                {obraSocialSeleccionada?.codigo !== "PART" && (
                  <InputV1
                    inputType="text"
                    name="txtAfiliado"
                    headerStr="Número de afiliado"
                    placeholderText="0020808"
                    onChange={onNroAfiliadoChange}
                    desactivado={!habilitarNumeroAfiliado}
                    value={registroState.registro.usuario.nro_afiliado}
                    errorStr="Ingresá un Numero de afiliado"
                    className="rb16m"
                    onKeyPress={preventKeyTexto}
                    maxLength="25"
                    checkError={registroState.registro.listError.nro_afiliado}
                    isRequired={true}
                  />
                )}
              </div>
            </IonCol>
            <IonCol size="12" sizeMd="6">
              {radio && obraSocialSeleccionada?.codigo !== "PART" && (
                <>
                  <div className="ptur-radio-obraSocial f-left">
                    <InputV1
                      inputType="radio"
                      labelStr="Obra social"
                      nombreRadio="tipoObraSocial"
                      name="txtObrasocial"
                      checked={
                        registroState.registro.usuario.tipo_iva !== "" &&
                        registroState.registro.usuario.tipo_iva === 0
                          ? true
                          : false
                      }
                      onChange={onChangeRadio}
                      value={true}
                    />
                  </div>
                  <div className="ptur-radio-obraSocial f-left">
                    <InputV1
                      inputType="radio"
                      labelStr="Prepaga"
                      nombreRadio="tipoObraSocial"
                      name="txtPrepaga"
                      onChange={onChangeRadio}
                      checked={
                        registroState.registro.usuario.tipo_iva !== "" &&
                        registroState.registro.usuario.tipo_iva === 1
                          ? true
                          : false
                      }
                      value={false}
                    />
                  </div>
                  <div className="clear"></div>
                </>
              )}
            </IonCol>
          </IonRow>
          <div className="ptur-footer-registros">
            <button
              onClick={() => crearCuenta()}
              className="btn ptur-btn-confirmar  bgc-primary c-white rb16m f-right"
              disabled={registroState.registro.loading}
              style={{
                minHeight: "40px",
                ...(registroState.registro.loading && {
                  paddingTop: 7,
                  paddingBottom: 6,
                }),
              }}
            >
              {registroState.registro.loading ? (
                <IonSpinner name="lines-small" />
              ) : (
                "Confirmar"
              )}
            </button>
            <button
              onClick={() => setMultitab(0)}
              className="btn ptur-btn-volver  b-latex30 rb16m c-latex30 f-left ptur-btnVolver-disableMoble"
              disabled={registroState.registro.loading}
            >
              Paso anterior
            </button>
          </div>
        </div>
      </IonGrid>
      {registroState.registro.loading && (
        <div className="ptur-registro-overlay">
          <div className="ptur-registro-spinner-container">
            <IonSpinner name="crescent" />
            <p className="rb16m c-white">Validando tus datos de registro...</p>
          </div>
        </div>
      )}
      <style>{`
      .ptur-registro-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      }

      .ptur-registro-spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
      }
    `}</style>
    </>
  );
};
export default Paso2;
